import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'ColorDot',
  props: {
    color: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "w-6 h-6 ml-2 mr-4 rounded-full hover:scale-110 hover:shadow transition-transform",
    style: _normalizeStyle({ 'background-color': _ctx.color })
  }, null, 4))
}
}

})